import template from './radio-control.html';
import controller from './radio-control.controller';

import './radio-control.styl';

let radioControlComponent = {
  restrict: 'E',
  bindings: {
      name: '@',
      model: '=',
      options: '='
  },
  template,
  controller
};

export default radioControlComponent;



// WEBPACK FOOTER //
// ./client/app/common/radio-control/radio-control.component.js